import React, { useState, useRef } from 'react';
import cmsUtils from '../../utils/cmsUtils';
import { Item } from '../../items/item';
import utils from '../../../utils';
import './style.scss';

export function ClubsTilesPanel(props) {
    const item = props.item;
    const subItems = item.items || [];
    const cmsOption = props.cmsOption || {};

    const cssClass = utils.classNames('cms_item', 'clubTilePanel', item.cssClass || item.anchorName || '');

    const subItemsElts = subItems.map((subItem, index) =>
        <Item item={subItem} key={subItem.itemId} cmsOption={cmsOption}></Item>
    );

    const sectionRefs = useRef({});

    const sortedTeams = subItemsElts.slice().sort((a, b) => {
        const teamA = a.props.item.payloads[3].value.toLowerCase();
        const teamB = b.props.item.payloads[3].value.toLowerCase();
        return teamA.localeCompare(teamB);
    })

    const teamsByLetter = sortedTeams.reduce((acc, team) => {
        const firstLetter = team.props.item.payloads[3].value[0].toUpperCase();
        if (!acc[firstLetter]) {
            acc[firstLetter] = [];
        }
        acc[firstLetter].push(team);
        return acc;
    }, {});

    const letterGroups = ["A\u00A0\u00A0\u00A0 B\u00A0\u00A0\u00A0 C\u00A0\u00A0\u00A0 ", "D\u00A0\u00A0\u00A0 E\u00A0\u00A0\u00A0 F\u00A0\u00A0\u00A0 G\u00A0\u00A0\u00A0 ", "H\u00A0\u00A0\u00A0 I\u00A0\u00A0\u00A0 J\u00A0\u00A0\u00A0 K\u00A0\u00A0\u00A0 L\u00A0\u00A0\u00A0 ", "M\u00A0\u00A0\u00A0 N\u00A0\u00A0\u00A0 O\u00A0\u00A0\u00A0 ", "P\u00A0\u00A0\u00A0 Q\u00A0\u00A0\u00A0 R\u00A0\u00A0\u00A0 ", "S\u00A0\u00A0\u00A0 ", "T\u00A0\u00A0\u00A0 U\u00A0\u00A0\u00A0 V\u00A0\u00A0\u00A0 W\u00A0\u00A0\u00A0 X\u00A0\u00A0\u00A0 Y\u00A0\u00A0\u00A0 Z"];

    const handleScrollTo = (group) => {
        // 找到当前 group 下最先出现的字母
        for (let letter of group) {
            console.log('scrolling to letter:', letter);
            if (sectionRefs.current[letter]) {
                sectionRefs.current[letter].scrollIntoView({ behavior: "smooth", block: "center" });
                return;
            } else {
                console.log(`No ref found for letter: ${letter}`);
            }
        }
    };

    // console.log("Club panel subitems:", subItemsElts);

    // console.log("team name:", sortedTeams[0].props.item.payloads[3].value);

    return (
        <section
            className={cssClass}
            id={item.anchorName}
            data-cms-item-id={cmsOption.isCmsEdit && item.itemId}
        >
            <div className='teams__group'>
                {letterGroups.map((group) => (
                    <button key={group} onClick={() => handleScrollTo(group)}>
                        {group}
                    </button>
                ))}
            </div>
            <div className='container-clubs-tiles'>
                {/* {sortedTeams} */}
                {sortedTeams.map((team) => {
                    const letter = team.props.item.payloads[3].value[0].toUpperCase();
                    return (
                        <div key={team.props.item.itemId}
                            ref={(el) => {
                                if (!sectionRefs.current[letter] && el) {
                                    sectionRefs.current[letter] = el;
                                }
                            }}>
                            {team}
                        </div>
                    );
                })}
            </div>
        </section>
    );
}